export default __webpack_public_path__ + "f0a78afe35b85dc42fff1cdea1f79e38.svg";